import { userContext } from '../userManager';

export const apiPeerProfilesGet = () => userContext.apiCall({ url: `/peer-profiles` });

export const apiPeerProfilesInstrumentsGet = (id, { startDate, endDate, numberOfClusters }) =>
  userContext.apiCall({
    url: `/peer-profiles/${id}/clustered-instruments`,
    qs: { startDate, endDate, numberOfClusters },
  });

export const apiPeerProfilesSelectedInstrumentsGet = id =>
  userContext.apiCall({
    url: `/peer-profiles/${id}/selected-instruments`,
  });
